export default "__VITE_ASSET__cff0d334__"